export default {
  EMAIL: 'email',
  ID: 'id',
  NAME: 'name',
  TENANT_ID: 'tenantId',
  SNAKE_USER_ID: 'user_id',
  CAMEL_USER_ID: 'userId',
};
